// extracted by mini-css-extract-plugin
export var actionButton = "_fo-t";
export var buttonContainer = "_fo-0";
export var buttonContainer2 = "_fo-1";
export var buttonSection = "_fo-2";
export var details = "_fo-3";
export var dropdownItem = "_fo-5";
export var dropdownItemsContainer = "_fo-4";
export var fileInput = "_fo-r";
export var headerButton = "_fo-6";
export var icon = "_fo-7";
export var input = "_fo-8";
export var macroListItem = "_fo-9";
export var mainContent = "_fo-a";
export var microText = "_fo-b";
export var modal = "_fo-w";
export var optionsButton = "_fo-c";
export var paperclip = "_fo-s";
export var pillContent = "_fo-d";
export var preview = "_fo-e";
export var preview2 = "_fo-f";
export var quillEditor = "_fo-q";
export var selectedMacro = "_fo-g";
export var sidebar = "_fo-h";
export var sidebarHeader = "_fo-j";
export var sidebarList = "_fo-i";
export var sidebarListItem = "_fo-k";
export var sidebarSearch = "_fo-l";
export var snoozeDurationWrapper = "_fo-v";
export var statusPillContainer = "_fo-m";
export var tagsContainer = "_fo-n";
export var unselectedMacro = "_fo-o";
export var variable = "_fo-u";
export var wrapper = "_fo-p";